import { api } from '@/core/api/';
import qs from 'querystring';

const apiUrl = 'api/sysparameter';

export const getSysparameterByNames = async (params) => {
  return await api.get(`${apiUrl}/byparameternames`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};
